module.exports = __webpack_public_path__ + "static/media/compex-logo.bdd1dff7.svg";